<app-left-side-nav></app-left-side-nav>
<app-header></app-header>
<div class="afterLoginPageContainer">
  <div class="mainContent">
    <div class="uploadPhoto p-4">
      <div class="headS d-flex justify-content-between align-items-center">
        <a class="font-weight-600">
          <i class="fa fa-angle-left" (click)="goback()"></i> Upgrade Your Ticket
        </a>      
      </div>
      <h5 class="font-weight-600 mt-4">Photo is mandatory for upgrade.</h5>
      <p>Please upload a clear photo with your face visible.</p>
      <div class="uploadPhotoBox d-flex flex-column align-items-center mt-5">
        <div class="imgOut mb-4" >
              <div class="img-box"
                  title="Image should be jpg, jpeg, png and less than 15 MB">
                  <img id="myImg" name="myImg"
                      [src]="uploadedImg || '/assets/images/default-profile-individual.png'"
                      onerror="this.src='/assets/images/default-profile-individual.png';"

                      alt="profile photo">
                  <span class="d-none"><i class="fa fa-pen"></i></span>
              </div>
        </div>
        <div class="err_msg image-err-msg my-2" *ngIf="invalidImages !== '' ">
          <p class="font-weight-600 mb-1">Error:</p>
          <p class="mt-0 mb-0">{{ invalidImages }}</p></div>
        <div class="text-center">

        <div class="success" *ngIf="photoUploadSuccess">
          <i class="fa fa-circle-check"></i>
          <p class="mb-0"> Photo Updated Successfully.</p>
        </div>

        <label class="btn photoUpBtn mt-4" [for]="'profilepic'">
          <input [id]="'profilepic'" name="profilepic" type="file"
              accept=".jpg,.jpeg,.png" class="d-none" (change)="onFileSelected($event)" />
          Upload Photo
        </label>
          
      </div>
      </div>      
    </div>
    <div class="actbtn" *ngIf="selectedFiles &&  invalidImages === ''">
        <div class="out">
          <button class="submitBtn"  (click)="onSubmit()">Submit</button>
        </div>      
      </div>
  </div>
</div>
